import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { METRIC, HYBRID, FEET, YARDS, KILOMETERS, MILES, METERS, SHORT } from '../constants'

export function getDistanceTo ({ to, system }) {
  if (to) { return to }
  return (system === METRIC || system === HYBRID) ? KILOMETERS : MILES
}

export function formatDistance ({ from = METERS, unit = SHORT, digits = 1, to: _to, system, ...rest } = {}) {
  const to = getDistanceTo({ from, to: _to, system })
  return formatUnit({ ...rest, from, to, unit, digits })
}

export function distanceFormatter ({ intl, locale, system } = {}) {
  return ({ ...options }) => formatDistance({ ...options, intl, locale, system })
}

export class FormattedDistance extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([ FEET, YARDS, METERS, KILOMETERS, MILES ]),
    to: PropTypes.oneOf([ FEET, YARDS, METERS, KILOMETERS, MILES ]),
  };

  static defaultProps = {
    from: METERS,
    unit: SHORT,
    digits: 1,
  }

  render () {
    const { to: _to, ...rest } = this.props
    const to = getDistanceTo({ to: _to, system: this.context.system })
    return React.createElement(FormattedUnit, { ...rest, to })
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/distance.js